import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./store";
import ErrorBoundary from "./components/ErrorBoundary";
import { authRoutes, userRoutes } from "./routes/allRoutes";
import Authmiddleware from "./routes/middleware/Authmiddleware";
import AppWrapper from "./AppWrapper";

// Design-system previews — DEV ONLY, never mounted in production builds.
const isDev = process.env.NODE_ENV === "development";
const UiKit = isDev ? require("./pages/UiKit/UiKit").default : null;
const ShellPreview = isDev ? require("./pages/UiKit/ShellPreview").default : null;

function App() {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <Router>
          <AppWrapper>
            <Switch>
              {isDev && UiKit ? (
                <Route path="/ui-kit" component={UiKit} />
              ) : null}
              {isDev && ShellPreview ? (
                <Route path="/shell-preview" component={ShellPreview} />
              ) : null}

              {authRoutes.map((route, index) => (
                <Authmiddleware
                  path={route.path}
                  component={route.component}
                  key={index}
                  isAuthProtected={false}
                />
              ))}

              {userRoutes.map((route, index) => (
                <Authmiddleware
                  path={route.path}
                  component={route.component}
                  key={index}
                  isAuthProtected
                  exact
                />
              ))}
            </Switch>
          </AppWrapper>
        </Router>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
